import type { HiddenIdentity } from '../types';

export const IDENTITIES: HiddenIdentity[] = [
  {
    id: 'undercover_rich',
    name: '卧底富豪',
    emoji: '🕵️',
    beforeRevealDesc: '正常游玩，隐藏身份',
    afterRevealDesc: '获得最富玩家15%资产 + 随机交换一块地产',
    revealEffect: '获得场上最富玩家资产的15%，并与其随机交换一块地产',
    balance: 'medium',
  },
  {
    id: 'poor_god',
    name: '穷神附体',
    emoji: '👻',
    beforeRevealDesc: '正常游玩，隐藏身份',
    afterRevealDesc: '选定一名玩家让其随机失去一座地产',
    revealEffect: '选定一名玩家，让其随机失去一座地产（非核心地产可豁免）',
    balance: 'medium',
  },
  {
    id: 'time_traveler',
    name: '时空旅人',
    emoji: '⏳',
    beforeRevealDesc: '正常游玩，隐藏身份',
    afterRevealDesc: '自己回到上一圈的位置和状态',
    revealEffect: '自己回到上一圈的位置和状态（不影响其他玩家）',
    balance: 'mild',
  },
  {
    id: 'miser',
    name: '守财奴',
    emoji: '🔒',
    beforeRevealDesc: '资产前50%时不触发厄运命运卡',
    afterRevealDesc: '免疫接下来2回合所有负面效果',
    revealEffect: '免疫接下来2个回合的所有负面效果',
    balance: 'defensive',
  },
];
